import { render, staticRenderFns } from "./perinfdiolg.vue?vue&type=template&id=7e7e5048&scoped=true"
import script from "./perinfdiolg.vue?vue&type=script&lang=js"
export * from "./perinfdiolg.vue?vue&type=script&lang=js"
import style0 from "./perinfdiolg.vue?vue&type=style&index=0&id=7e7e5048&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e7e5048",
  null
  
)

export default component.exports